import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useSite } from "@/lib/content";
import { adminApi, formatError, rules } from "@/lib/adminApi";
import { Checkbox, SaveButton, SectionHeader } from "@/pages/admin/ui";

export default function SettingsSection() {
  const { content, reload } = useSite();
  const [s, setS] = useState(null);
  const [emails, setEmails] = useState("");
  const [formEnabled, setFormEnabled] = useState(!!content.forms?.group_request?.enabled);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    adminApi.get("/admin/settings").then(({ data }) => {
      setS(data);
      setEmails(data.notification_emails.join("\n"));
    }).catch((e) => toast.error(formatError(e)));
  }, []);

  const list = emails.split(/[\n,;]+/).map((e) => e.trim()).filter(Boolean);
  const bad = list.filter((e) => rules.email(e) !== true);

  const onSave = async () => {
    if (bad.length) return toast.error(`Geçersiz e-posta: ${bad.join(", ")}`);
    setSaving(true);
    try {
      const { data } = await adminApi.put("/admin/settings", { site_live: s.site_live, en_live: !!s.en_live, notification_emails: list });
      await adminApi.put("/admin/content/forms", { group_request: { enabled: formEnabled } });
      setS(data);
      await reload();
      toast.success("Kaydedildi");
    } catch (e) {
      toast.error(formatError(e));
    } finally {
      setSaving(false);
    }
  };

  if (!s) return <p className="text-ink-muted">Yükleniyor…</p>;
  return (
    <section data-testid="admin-section-ayarlar">
      <SectionHeader title="Ayarlar" />
      <div className="grid gap-4 max-w-2xl">
        <div className="rounded-2xl border border-line bg-white p-5 space-y-2">
          <label htmlFor="notify-emails" className="text-sm font-semibold text-wood">Bildirim e-postaları</label>
          <textarea id="notify-emails" rows={3} value={emails} onChange={(e) => setEmails(e.target.value)} placeholder="ornek@alanadi.com" className="w-full rounded-xl border border-line px-4 py-3 text-base" data-testid="settings-emails-input" />
          <p className="text-xs text-ink-muted">Her satıra bir adres (en fazla 5). Yeni grup talebi geldiğinde bu adreslere e-posta gönderilir. Boş bırakılırsa talepler yine kaydedilir.</p>
          {bad.length > 0 && <p className="text-sm text-[#B42318]" data-testid="settings-emails-error">Geçersiz e-posta: {bad.join(", ")}</p>}
        </div>
        <div className="rounded-2xl border border-line bg-white p-5">
          <Checkbox id="form-enabled" label="Grup talep formu canlı sitede açık" checked={formEnabled} onChange={setFormEnabled} testId="settings-form-enabled" />
        </div>
        <div className="rounded-2xl border border-line bg-white p-5 space-y-2">
          <Checkbox id="en-live" label="İngilizce sürüm yayında" checked={s.en_live} onChange={(v) => setS({ ...s, en_live: v })} testId="settings-en-live" />
          <p className="text-xs text-ink-muted">Kapalıyken dil seçici gizlenir, /en sayfaları yalnızca yöneticiye açılır ve hreflang eklenmez. Açıkken bile yalnızca doğrulanmış İngilizce metinler görünür.</p>
        </div>
        <div className="rounded-2xl border border-line bg-white p-5 space-y-2">
          <Checkbox id="site-live" label="Site yayında mı?" checked={s.site_live} onChange={(v) => setS({ ...s, site_live: v })} testId="settings-site-live" />
          <p className="text-xs text-ink-muted" data-testid="settings-noindex-note">
            {s.public_site_url
              ? `Alan adı: ${s.public_site_url}. Site yayında işaretlenirse arama motorlarından gizleme (noindex) kaldırılır.`
              : "Henüz alan adı tanımlı değil. Site yayında işaretlense bile arama motorlarından gizleme (noindex) açık kalır."}
          </p>
        </div>
      </div>
      <div className="mt-6"><SaveButton onClick={onSave} saving={saving} testId="admin-save-ayarlar" /></div>
    </section>
  );
}
